import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

// Assets
import { TriangleCautionIcon } from "~/assets/svg/InterfaceIcon";

const Return = ({ detailData, navigate }) => {
	const { t } = useTranslation();
	return (
		<section className="c__card evaluate-card return-card">
			<div className="content">
				<h5 className="ico">
					<TriangleCautionIcon />
				</h5>
				<p className="main">
					{t("pages.investment.InvestEvalPage.detail.Step.return.main")}
				</p>
				<p className="sub pre">
					{t("pages.investment.InvestEvalPage.detail.Step.return.sub")}
				</p>
				<p className="date">
					{t("pages.investment.InvestEvalPage.detail.Step.return.date")}{" "}
					{moment(detailData.completeDate).format("YYYY-MM-DD")}
				</p>
			</div>
			<div className="card-bottom">
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={() => navigate("/invest/evaluate")}
				>
					{t("pages.investment.InvestEvalPage.detail.Step.return.confirm")}
				</button>
			</div>
		</section>
	);
};

export default Return;
